import React, { useState } from 'react';

function SubmitForm({ selectedData, model }) {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        company: '',
        email: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        console.log('Selected Data:', selectedData);
        console.log('Model:', model);
        // Add logic to handle form submission, e.g., API call
    };

    return (
        <div className="nf-form-cont">
        <form className="submit" onSubmit={handleSubmit}>
            <div className="nf-form-content">
                <label htmlFor="name">Name</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    className="ninja-forms-field"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="nf-form-content">
                <label htmlFor="phone">Phone Number</label>
                <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    className="ninja-forms-field"
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="nf-form-content">
                <label htmlFor="company">Company Name</label>
                <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    className="ninja-forms-field"
                    onChange={handleChange}
                />
            </div>
            <div className="nf-form-content">
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    className="ninja-forms-field"
                    onChange={handleChange}
                    required
                />
            </div>
            <button type="submit" className="submit-button">
                Submit
            </button>
        </form>
        </div>
    );
}

export default SubmitForm;


